import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ASSET_BASE_URL } from '../config/constants';

// Blog post metadata
export const blogPosts = [
  {
    slug: 'introducing-bonzai-file-visualization',
    title: 'Introducing Bonzai: File Visualization for Vibe Coding with Cursor IDE and Claude UI',
    description: 'Fight context rot and tech debt during vibe coding sessions. Bonzai gives you real-time file visualization for Cursor IDE, Claude UI, and AI coding workflows.',
    date: '2026-01-28',
    author: 'Bonzai Team'
  }
];

function Blog() {
  return (
    <div style={{
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
    }}>
      <Helmet>
        <title>Blog - Bonzai</title>
        <meta name="description" content="Insights and updates from the Bonzai team on AI-assisted coding and file visualization." />
      </Helmet>

      {/* Header */}
      <header style={{
        padding: '24px',
        borderBottom: '1px solid #eee'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Link to="/" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            textDecoration: 'none'
          }}>
            <img
              src={`${ASSET_BASE_URL}/favicon.jpg`}
              alt="Bonzai"
              style={{ width: '32px', height: '32px', borderRadius: '6px' }}
            />
            <span style={{ fontSize: '20px', fontWeight: '600', color: '#333' }}>bonzai</span>
          </Link>
          <nav style={{ display: 'flex', gap: '24px' }}>
            <Link to="/visualize" style={{ color: '#666', textDecoration: 'none', fontSize: '14px' }}>Visualize</Link>
            <Link to="/blog" style={{ color: '#333', textDecoration: 'none', fontSize: '14px', fontWeight: '500' }}>Blog</Link>
          </nav>
        </div>
      </header>

      {/* Content */}
      <main style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '48px 24px'
      }}>
        <h1 style={{
          fontSize: '36px',
          fontWeight: '700',
          color: '#333',
          marginBottom: '48px'
        }}>
          Blog
        </h1>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
          {blogPosts.map(post => (
            <article key={post.slug}>
              <Link
                to={`/blog/${post.slug}`}
                style={{ textDecoration: 'none' }}
              >
                <h2 style={{
                  fontSize: '24px',
                  fontWeight: '600',
                  color: '#333',
                  marginBottom: '8px',
                  transition: 'color 0.15s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#3B82F6'}
                onMouseLeave={(e) => e.target.style.color = '#333'}
                >
                  {post.title}
                </h2>
              </Link>
              <p style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.6',
                marginBottom: '8px'
              }}>
                {post.description}
              </p>
              <time style={{
                fontSize: '14px',
                color: '#999'
              }}>
                {new Date(post.date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </time>
            </article>
          ))}
        </div>
      </main>
    </div>
  );
}

export default Blog;
